import { StubErrorBoundary, StubPage } from '#app/components/stub-page.tsx'
import { type Route } from './+types/index.ts'

export const meta: Route.MetaFunction = () => [
	{ title: 'Uutiset — Frisbeegolfradat' },
]

export default function Index() {
	return (
		<StubPage
			eyebrow="Yhteisö"
			title="Uutiset"
			intro="Lajin tuoreimmat uutiset ja kuulumiset."
		/>
	)
}

export { StubErrorBoundary as ErrorBoundary }
